import React, { useState } from "react";
import "./Previewfile.css";
import { RiFileCloseLine } from "react-icons/ri";

interface PreviewfileProps {
  onClear?: () => void;
  previewData: any[];
  selectedFileName?: string;
}

const Previewfile: React.FC<PreviewfileProps> = ({ onClear, previewData, selectedFileName }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleClearClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmYes = () => {
    setShowConfirmModal(false);
    if (onClear) {
      onClear();
    }
  };

  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };

  return (
    <>
      <div className="preview-header">
        <div className="preview-header-left">
          <h2 className="preview-title">
            <strong>{selectedFileName}</strong> (preview data)
          </h2>
          <p className="preview-subtitle">{previewData.length} results</p>
        </div>
        <button className="preview-clear-btn" title="Clear files" onClick={handleClearClick}>
          <RiFileCloseLine size={20} />
        </button>
      </div>

      <div className="preview-container">
        
          {previewData.length === 0 ? (
            <p>No data available for preview</p>
          ) : (
            <table className="preview-table">
              <tbody>
                <tr className="preview-header-row">
                  {Object.keys(previewData[0]).map((key) => (
                    <th key={key}>{key}</th>
                  ))}
                </tr>
                {previewData.map((row, idx) => (
                  <tr
                    key={idx}
                    className={idx % 2 === 0 ? "preview-row-even" : "preview-row-odd"}
                  >
                    {Object.keys(previewData[0]).map((key) => (
                      <td key={key}>{row[key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        
      </div>

      {/* Custom Confirmation Modal */}
      {showConfirmModal && (
        <div className="confirm-modal-overlay">
          <div className="confirm-modal">
            <div className="confirm-modal-body">
              <p>Are you sure you want to clear preview data?</p>
            </div>
            <div className="confirm-modal-footer">
              <button className="confirm-btn confirm-btn-no" onClick={handleConfirmNo}>
                No
              </button>
              <button className="confirm-btn confirm-btn-yes" onClick={handleConfirmYes}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Previewfile;
